import { Button } from 'primereact/button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
const CheckoutSuccess = () => {
    const { t } = useTranslation();
    return (
        <div className="p-4">
            <div className='grid items-center place-items-center content-center h-max'>
                <img alt="no_data" className="w-120" src="/svg/landing.svg"></img>
                <div className='flex items-center flex-wrap'>
                    <p className='text-xl font-semibold text-gray-600 text-center'>{t('order_placed_successfully')}</p>
                    <div className='hidden lg:block md:block'>
                        <video src='/img/heart.mp4'
                            height={50}
                            width={50}
                            autoPlay
                            playsInline
                            loop
                            className='text-center'
                        />
                    </div>
                </div>
                <div className='lg:hidden md:hidden'>
                    <video src='/img/heart.mp4'
                        height={50}
                        width={50}
                        autoPlay
                        playsInline
                        loop
                    />
                </div>
                <div className='my-4'>
                    <Link
                        to='/shop'
                    >
                        <Button outlined
                            label={t('continue_shopping')}
                            rounded
                            severity="secondary"
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
}
export default CheckoutSuccess;